import { render, staticRenderFns } from "./ReportSection.vue?vue&type=template&id=87f10712&scoped=true&"
import script from "./ReportSection.vue?vue&type=script&lang=js&"
export * from "./ReportSection.vue?vue&type=script&lang=js&"
import style0 from "./ReportSection.vue?vue&type=style&index=0&id=87f10712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f10712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87f10712')) {
      api.createRecord('87f10712', component.options)
    } else {
      api.reload('87f10712', component.options)
    }
    module.hot.accept("./ReportSection.vue?vue&type=template&id=87f10712&scoped=true&", function () {
      api.rerender('87f10712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/ReportSection.vue"
export default component.exports